import { connect } from 'react-redux';
import TeamAvailabilityForm from '../../../components/Dashboard/TeamAvailability/TeamAvailabilityForm';
import { getTeamAvailability } from '../../../actions/areas/Dashboard';

const mapStateToProps = ({
  areas: {
    dashboard: { teamAvailabilityReducer },
  },
}) => {
  const { teamsAvailability } = teamAvailabilityReducer.teamsAvailability;
  const { isFetching } = teamAvailabilityReducer;
  return {
    teamsAvailability,
    isFetching,
  };
};

const mapDispatchToProps = dispatch => ({
  getTeamAvailability: data => dispatch(getTeamAvailability(data)),
});

const TeamAvailability = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TeamAvailabilityForm);

export default TeamAvailability;
